var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "service-details-content" } },
    [
      !_vm.servicesData.is_doctor_work_at_lpu
        ? _c(_setup.BaseAlert, {
            class: _setup.isMobile ? "mb-4" : "mb-5",
            attrs: {
              "data-qa": "service-details-content_not_is_doctor_work_at_lpu",
              color: "text-secondary",
              text: _setup.t(
                "Врач больше не работает в клинике, где выполнял услуги. Цена может отличаться.",
                _setup.optionsLang
              ),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.servicesData.results, function (service, index) {
        return _c(
          "div",
          {
            key: index,
            class: { "mt-4": index !== 0 },
            attrs: { "data-qa": "service-details-content_service" },
          },
          [
            service.name
              ? _c(
                  "div",
                  {
                    staticClass: "text-body-1 text--text mb-2",
                    attrs: {
                      "data-qa": "service-details-content_service_name",
                    },
                  },
                  [_vm._v("\n      " + _vm._s(service.name) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            service.category
              ? _c(
                  "div",
                  {
                    staticClass: "text-body-2 text-secondary--text mb-2",
                    attrs: {
                      "data-qa": "service-details-content_service_category",
                    },
                  },
                  [_vm._v("\n      " + _vm._s(service.category) + "\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-wrap align-center mt-2" }, [
              _c(
                "span",
                {
                  staticClass:
                    "service-details-content-item text-subtitle-2 text--text",
                  attrs: { "data-qa": "service-details-content_service_price" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _setup.getFormattedPrice(service.quantity * service.price)
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              service.quantity > 1
                ? _c(
                    "span",
                    {
                      staticClass:
                        "service-details-content-item text-body-2 text-info--text",
                      attrs: {
                        "data-qa": "service-details-content_service_quantity",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(service.quantity) +
                          " х " +
                          _vm._s(_setup.getFormattedPrice(service.price))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              service.dt_last_price
                ? _c(
                    "span",
                    {
                      staticClass:
                        "service-details-content-item text-body-2 text-info--text",
                      attrs: {
                        "data-qa":
                          "service-details-content_service_dt_last_price",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_setup.t("цена на", _setup.optionsLang)) +
                          " " +
                          _vm._s(_setup.getDate(service.dt_last_price))
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }